import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import NavBar from './components/NavBar';
import HomePage from './pages/HomePage';
import TimelinePage from './pages/TimelinePage';
import AboutPage from './pages/AboutPage';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;

const LegalFooter = styled.footer`
  background: ${props => props.theme.colors.surface};
  border-top: 1px solid ${props => props.theme.colors.borderLight};
  padding: 20px;
  margin-top: 40px;
  text-align: center;
  font-size: 0.8rem;
  color: ${props => props.theme.colors.textSecondary};
  
  p {
    margin: 5px 0;
  }
  
  a {
    color: #64ffda;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

function ThemedApp() {
  const { themeData } = useTheme();

  return (
    <Router>
      <AppContainer theme={themeData}>
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/timeline" element={<TimelinePage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
        <LegalFooter theme={themeData}>
          <p>© 2025 Singularity Countdown. All rights reserved.</p>
          <p>This is a personal project for educational and entertainment purposes.</p>
          <p>Predictions are sourced from various futurists and technology experts and should not be considered as investment or professional advice.</p>
        </LegalFooter>
      </AppContainer>
    </Router>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ThemedApp />
        <Analytics />
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
